import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

interface RevenuePayment {
  idDocumento: string;
  nuovoIncassoAttivo: boolean;
  saldaRichiesto?: boolean;
}

@Component({
  providers: [provideTranslocoScope('receipts')],
  selector: 'rev-receipts-payment-settled-cell',
  imports: [TranslocoPipe, MatButtonModule],
  template: `
    <button
      matButton="outlined"
      type="button"
      [disabled]="!itemData.nuovoIncassoAttivo"
      [attr.aria-label]="(('receipts.ui.segnaComeSaldato' | transloco) + &quot; &quot;) + itemData.idDocumento"
      (click)="salda($event)"
    >
      {{ 'receipts.ui.saldato' | transloco }}
    </button>
  `,
  styles: `
    :host {
      display: flex;
      justify-content: center;
    }
  `,
})
export class receiptsPaymentSettledCell {
  @Input({ required: true }) itemData!: RevenuePayment;
  @Input() infoColumn: unknown;
  @Input() _reloadData?: { emit: () => void };

  // reloadData non porta payload: il parent legge questo flag.
  salda(event: MouseEvent): void {
    event.stopPropagation();

    this.itemData.saldaRichiesto = true;
    this._reloadData?.emit();
  }
}
